import {CompetitorSimple} from './competitor';

export class AddCrewResponseEntity {
  crewNumbers: number[];
  availableCompetitors: CompetitorSimple[];

  constructor(
    crewNumbers = [],
    availableCompetitors = []
  ) {
    this.crewNumbers = crewNumbers;
    this.availableCompetitors = availableCompetitors;
  }
}
